import { useTranslation } from 'react-i18next';
import teamService from '@/services/teamService.ts';
import ConfirmDestructiveModal from '@/components/shared/ConfirmDestructiveModal.tsx';

interface Props {
  isOpen: boolean;
  salesperson: { id: string; firstName: string; lastName: string } | null;
  onClose: () => void;
  onDeleted: () => void;
}

export default function DeleteSalespersonModal({ isOpen, salesperson, onClose, onDeleted }: Props) {
  const { t } = useTranslation();

  if (!salesperson) return null;

  const handleConfirm = async () => {
    await teamService.deleteSalesperson(salesperson.id);
    onDeleted();
    onClose();
  };

  return (
    <ConfirmDestructiveModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleConfirm}
      title={t('deleteSalesperson.title')}
      description={t('deleteSalesperson.confirmMessage', {
        name: `${salesperson.firstName} ${salesperson.lastName}`,
      })}
      confirmLabel={t('common.delete')}
      confirmingLabel={t('common.deleting')}
      errorFallback={t('deleteSalesperson.error')}
    />
  );
}
